import React, { useState } from "react";
import get from "lodash/get";
import { useSelector } from "react-redux";
import { PrivacyPolicy } from "./privacy-policy";
import { Liitannaisten } from "./liitannaisten";
import { AsiakasPalvelu } from "./asiakaspalvelu";
import { OhjeetApua } from "../ohjeet-ja-apua";
import { TilausJaOhjeet } from "./tilaus-ja-ohjeet";

const FooterPage = () => {


  const getState = useSelector((state) => state);
  const isFooterPrivacyPolicyClicked = get(getState, ["isFooterPrivacyPolicyClicked"], false);
  const isFooterLiitannaisetClicked = get(getState, ["isFooterLiitannaisetClicked"], false);
  const isFooterAsiakaspalveluClicked = get(getState, ["isFooterAsiakaspalveluClicked"], false);
  const isFooterOhjeetJaApuaClicked = get(getState, ["isFooterOhjeetJaApuaClicked"], false);
  const isFooterTilausJaOhjeetClicked = get(getState, ["isFooterTilausJaOhjeetClicked"], false);

  return (
    <div>
    { isFooterPrivacyPolicyClicked&&
    <PrivacyPolicy />}
    { isFooterLiitannaisetClicked&&
    <Liitannaisten />}
    { isFooterAsiakaspalveluClicked&&
    <AsiakasPalvelu />}
    { isFooterOhjeetJaApuaClicked&&
    <OhjeetApua/>}
    { isFooterTilausJaOhjeetClicked&&
    <TilausJaOhjeet/>}
    </div>
  );
};

export { FooterPage };
